import { createListenCollectionEpic, createListenDocEpic } from 'src/firebase';
import { actions, actionTypes } from './redux';

const ListenFeaturedAdsEpic$ = createListenCollectionEpic({
  collection: 'featuredAds',
  listenType: actionTypes.LISTEN_COLLECTION,
  unlistenType: actionTypes.UNLISTEN_COLLECTION,
  changeCollection: actions.changeCollection,
});

const ListenFeaturedAdsDetailEpic$ = createListenDocEpic({
  collection: 'featuredAds',
  listenType: actionTypes.LISTEN_DOC,
  unlistenType: actionTypes.UNLISTEN_DOC,
  changeDoc: actions.changeDoc,
});

export {
    ListenFeaturedAdsEpic$,
    ListenFeaturedAdsDetailEpic$
};



// WEBPACK FOOTER //
// ./src/featuredAds/epics.ts